import { createContext, useContext } from 'react';
import type { SessionUser } from '@movo/contracts/api/auth';
import { EMPTY_ABILITY, type AppAbility } from '../model/ability';

export type Session = { user: SessionUser | null; loading: boolean };

export const SessionContext = createContext<Session | null>(null);

// Fuori da un provider non si concede niente.
export const AbilityContext = createContext<AppAbility>(EMPTY_ABILITY);

/** `{ user, loading }`: `user` è `null` senza sessione. */
export function useSession() {
  const session = useContext(SessionContext);
  if (!session) {
    throw new Error("useSession deve essere usato all'interno di AuthProvider");
  }
  return session;
}

export const useAppAbility = () => useContext(AbilityContext);
